import { ShippingMethod } from '~/lib/data-contract/salesforce';

export type DeliveryMethod =
    | 'dropPoint'
    | 'addressDelivery'
    | 'clickAndCollect'
    | 'truckDelivery'
    | 'virtual';

export type Carriers = Record<DeliveryMethod, ShippingMethod[]>;

export type Carrier = Record<DeliveryMethod, ShippingMethod>;

export enum DeliveryTypes {
    truck = 'TRUCK',
    clickAndCollect = 'CLICK_AND_COLLECT',
    addressDelivery = 'ADDRESS_DELIVERY',
    dropPoint = 'DROPPOINT',
    virtual = 'VIRTUAL_DELIVERY',
}

export enum Defaults {
    phoneNumber = '12345678',
}
